document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.entry-header-stot');
  const iframeSelector = '.iframe_kh_wrapper iframe.singlegame-iframe';

  if (!header || !header.querySelector(iframeSelector)) {
    return;
  }

  const automaticPlaceholder = header.dataset.automaticPlaceholder === '1';
  const failClass = 'entry-header-stot--iframe-failed';
  const loadedClass = 'entry-header-stot--iframe-loaded';
  const placeholderClass = 'entry-header-stot__iframe-placeholder';
  const placeholderContentClass = 'entry-header-stot__iframe-placeholder-content';
  const timeoutMs = 2000;
  let timeoutId = null;

  const ensurePlaceholder = function () {
    const wrapper = header.querySelector('.iframe_kh_wrapper');
    if (!wrapper || wrapper.querySelector(`.${placeholderClass}`)) {
      return;
    }

    const titleText = header.dataset.placeholderTitle || '';
    const descriptionText = header.dataset.placeholderDescription || '';
    const ctaText = header.dataset.placeholderCtaText || '';
    const ctaLink = header.dataset.placeholderCtaLink || '';

    const placeholder = document.createElement('div');
    const contentWrapper = document.createElement('div');
    const title = document.createElement('h2');
    const description = document.createElement('p');
    const link = document.createElement('a');

    placeholder.className = placeholderClass;
    contentWrapper.className = placeholderContentClass;
    title.textContent = titleText;
    description.textContent = descriptionText;
    link.textContent = ctaText;
    link.href = ctaLink;

    placeholder.appendChild(contentWrapper);
    
    const icon = document.createElement('img');
    icon.className = 'entry-header-stot__iframe-placeholder-icon';
    icon.src = '/wp-content/themes/norgecasino-resp/img/slot-placeholder-icon.svg';
    icon.role = 'presentation';
    icon.alt = '';
    contentWrapper.appendChild(icon);
    
    contentWrapper.appendChild(title);
    contentWrapper.appendChild(description);
    contentWrapper.appendChild(link);

    const iframe = wrapper.querySelector('iframe.singlegame-iframe');
    if (iframe) {
      iframe.insertAdjacentElement('afterend', placeholder);
      return;
    }

    wrapper.appendChild(placeholder);
  };

  const removePlaceholder = function () {
    const wrapper = header.querySelector('.iframe_kh_wrapper');
    const placeholder = wrapper
      ? wrapper.querySelector(`.${placeholderClass}`)
      : null;
    if (placeholder) {
      placeholder.remove();
    }
  };

  const markFailed = function () {
    if (header.classList.contains(loadedClass)) {
      return;
    }

    header.classList.add(failClass);
    ensurePlaceholder();
  };

  const markLoaded = function () {
    header.classList.add(loadedClass);
    header.classList.remove(failClass);
    removePlaceholder();
  };

  const watchIframe = function (iframe) {
    if (!iframe) {
      return false;
    }

    clearTimeout(timeoutId);

    let resolved = false;
    const onLoad = function () {
      if (resolved) {
        return;
      }

      resolved = true;
      clearTimeout(timeoutId);
      markLoaded();
    };

    const onFail = function () {
      if (resolved) {
        return;
      }

      resolved = true;
      clearTimeout(timeoutId);
      markFailed();
    };

    iframe.addEventListener('load', onLoad, { once: true });
    iframe.addEventListener('error', onFail, { once: true });
    timeoutId = window.setTimeout(onFail, timeoutMs);

    return true;
  };

  if (!automaticPlaceholder) {
    markFailed();

    return;
  }

  if (watchIframe(header.querySelector(iframeSelector))) {
    return;
  }

  const demoButton = header.querySelector('.iframe_kh_wrapper .play-demo-btn');
  if (demoButton) {
    demoButton.addEventListener(
      'click',
      function () {
        window.setTimeout(function () {
          if (!watchIframe(header.querySelector(iframeSelector))) {
            markFailed();
          }
        }, 150);
      },
      { once: true }
    );
  }
});